import { createStore } from 'vuex';

import user from './modules/user';
import help from './modules/help';
import unbinding from './modules/unbinding';
import deleteData from './modules/deleteData';
import { SET_TITLE, SET_VISIBLE_TOP, SET_NAVIGATION_APP, SET_DEBUG, SET_SHARE_WECHAT, SET_AREA_CONFIG, SET_THEME } from './mutationTypes';

export default createStore({
  state: {
    debug: false,
    title: '',
    visibleTop: false,
    visibleApp: false,
    // 显示顶部打开APP导航的路由
    visbleAppRouters: ['detail'],
    // 隐藏顶部打开APP导航的路由
    hideAppRouters: ['user-register-wechat', 'user-register', 'download', 'my-invite-download', 'member-sign', 'member-equity', 'member-rule', 'member-sign-rule'],
    // 隐藏tabbar的路由
    hideTopRouters: [],
    shareWechat: false,
    areaConfig: {
      items: [],
      areaNo: JSON.parse(window.localStorage.getItem('areaNo') || '""'),
    },
    theme: 'light',
  },
  mutations: {
    // 设置标题
    [SET_TITLE](states, newValue) {
      Object.assign(states, { title: newValue });
      document.title = newValue || '';
      setTimeout(() => {
        // 兼容 appWebview监听history模式地址栏改变
        const origin = `${window.location.protocol}//${window.location.host}`;
        if (window.ReactNativeWebView) return window.ReactNativeWebView.postMessage(JSON.stringify({ length: window.history.length }));
        return window.postMessage(JSON.stringify({ length: window.history.length }), origin);
        // window.postMessage(window.history.length);
      });
    },
    // 头部标题栏
    [SET_VISIBLE_TOP](states, newValue) {
      Object.assign(states, { visibleTop: newValue });
    },
    // app导航
    [SET_NAVIGATION_APP](states, newValue) {
      Object.assign(states, { visibleApp: newValue });
    },
    [SET_DEBUG](states, newValue = false) {
      Object.assign(states, { debug: newValue });
    },
    [SET_SHARE_WECHAT](states, newValue = false) {
      Object.assign(states, { shareWechat: newValue });
    },
    [SET_AREA_CONFIG](states, newValue) {
      if (newValue.areaNo) {
        window.localStorage.setItem('areaNo', JSON.stringify(newValue.areaNo));
      }
      console.log(newValue);
      Object.assign(states, { areaConfig: newValue });
    },
    [SET_THEME](states, newValue) {
      Object.assign(states, { theme: newValue });
    },
  },
  actions: {},
  modules: {
    user,
    help,
    unbinding,
    deleteData,
  },
});
